import {TabPanel, TabView} from 'primereact/tabview';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseContainer from '../baseContainers/BaseContainer';
import ActionButton from '../components/ActionButton';
import {CustomMessages} from '../components/CustomMessages';
import BlockUi from '../components/waitPanel/BlockUi';
import OrderFuelService from '../services/OrderFuelService';
import DraftListContainer from './DraftListContainer';
import OrderListContainer from './OrderListContainer';
class OrderDraftsListContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.service = new OrderFuelService();
        this.state = {
            activeIndex: 0,
            draftsCount: 0,
            ordersCount: 0,
        };
        this.handleTabChange = this.handleTabChange.bind(this);
        this.onAfterGetList = this.onAfterGetList.bind(this);
        this.afterGetListError = this.afterGetListError.bind(this);
    }

    componentDidMount() {
        super.componentDidMount();
        this.blockUi();
        let activeIndex = this.readCookie(`order-list-activeIndex`);
        if (activeIndex === undefined || activeIndex === null || activeIndex === '') {
            activeIndex = 0;
        }
        this.setState({activeIndex: parseInt(activeIndex)});
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    handleTabChange(e) {
        this.setState(
            {
                activeIndex: e.index,
            },
            () => {
                this.saveCookie(`order-list-activeIndex`, this.state.activeIndex);
            }
        );
    }

    readCookie(cookieName) {
        return sessionStorage.getItem(cookieName);
    }

    saveCookie(cookieName, cookieValue) {
        sessionStorage.setItem(cookieName, cookieValue);
    }

    render() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                    rendered={!this.props.embedded}
                >
                    <div className='header-dialog-button-container'>
                        <ActionButton
                            label={t('order-fuel.orderFuel')}
                            variant='left-button save-button blue '
                            handleClick={() => (window.location.href = this.props.newUrl)}
                        />
                    </div>
                    <div className='container-fluid'>
                        <TabView activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange}>
                            <TabPanel header={`${t('order-fuel.orders')} (${this.state.ordersCount})`}>
                                <OrderListContainer
                                    onAfterGetList={this.onAfterGetList}
                                    afterGetListError={this.afterGetListError}
                                    blockUi={this.blockUi}
                                    unblockUi={this.unblockUi}
                                    showMessage={this.showMessage}
                                    embedded
                                    _isMounted={this._isMounted}
                                />
                            </TabPanel>
                            <TabPanel header={`${t('order-fuel.orderDarfts')} (${this.state.draftsCount})`}>
                                <DraftListContainer
                                    onAfterGetList={this.onAfterGetList}
                                    afterGetListError={this.afterGetListError}
                                    blockUi={this.blockUi}
                                    unblockUi={this.unblockUi}
                                    showMessage={this.showMessage}
                                    embedded
                                    _isMounted={this._isMounted}
                                />
                            </TabPanel>
                        </TabView>
                    </div>
                </BlockUi>
            </React.Fragment>
        );
    }

    onAfterGetList(data) {
        this.setState({ordersCount: data.ordersCount, draftsCount: data.draftsCount}, this.unblockUi());
    }

    afterGetListError() {
        this.unblockUi();
    }
}

OrderDraftsListContainer.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    newUrl: '/#/order-new',
};

OrderDraftsListContainer.propTypes = {
    newUrl: PropTypes.string,
    viewMode: PropTypes.string,
};

export default withTranslation()(OrderDraftsListContainer);
